import { combineReducers } from "redux";
import profileReducer from "./profile";
import kybReducer from "./kybflow";
import businessReducer from "./business";
import authReducer from "./auth";
import storeReducer from "./store";
import chat from "./chat";
import modalReducer from "./modalReducer";

export default combineReducers({
  profileReducer,
  kybReducer,
  businessReducer,
  authReducer,
  storeReducer,
  chat,
  modalReducer,
});
